import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormCreationComponent } from './form-creation/form-creation.component';
import { FormPreviewComponent } from './form-preview/form-preview.component';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../shared/shared.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormPreviewV2Component } from './form-preview-v2/form-preview-v2.component';
import { TagModule } from 'primeng/tag';
import { GradientPickerComponent } from '../shared/gradient-picker/gradient-picker.component';
import { GradientCssPipe } from '../shared/gradient-picker/gradient-css.pipe';
import { Drawer } from "primeng/drawer";
import { Popover } from "primeng/popover";
import { SelectModule } from 'primeng/select';

@NgModule({
  declarations: [
    FormCreationComponent,
    FormPreviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    TextareaModule,
    ToastModule,
    SharedModule,
    ProgressSpinnerModule,
    FormPreviewV2Component,
    TagModule,
    GradientPickerComponent,
    GradientCssPipe,
    Drawer,
    Popover,
    SelectModule
],
  providers: [
    MessageService
  ],
  exports: [
    FormCreationComponent,
    FormPreviewComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class FormBuilderModule { }